












import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { StandardOption } from "../../system/selectors/mixins";
import { DepartmentSelectableMixin } from "./mixins";
import { Department } from "../../../domain/department";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class DepartmentDropDownSelector extends Mixins(DepartmentSelectableMixin) {
  @Prop({ default: true })
  isClearable: boolean;

  @Watch("isLoaded")
  onIsLoadedUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.loaded(this.options);
    }
  }

  @Emit()
  loaded(options: StandardOption<Department>[]): void {}
}
